// Global
import { Button } from "antd";
import React, { useState } from "react";

// CSS
import './CreateContractOptions.module.css';

const options_governance = [
    { key: "mint", label: "Mint" },
    { key: "burn", label: "Burn" },
    { key: "stacking", label: "Stacking" },
    { key: "global-burn", label: "Global Burn" },
];
const options_security = [
    { key: "freeze", label: "Freeze" },
    { key: "blacklist", label: "Blacklist" },
    { key: "backup", label: "Backup" },
    { key: "revoke", label: "Revoke" },
    { key: "smart-swap", label: "Smart Swap" },
];

const CreateContractOptions: React.FC = () => {
    const [selected, setSelected] = useState<{ [key: string]: boolean }>({});

    const handleClick = (key: string) => {
        setSelected(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };
        
    const OneButton: React.FC<{ opt: { key: string; label: string } }> = ({ opt }) => {
        return(<Button
            key={opt.key}
            color={selected[opt.key] ? "geekblue" : "default"}
            variant={selected[opt.key] ? "solid" : "outlined"}
            onClick={() => handleClick(opt.key)}
            ghost={selected[opt.key] ? false : true }
            style={{padding:"1.8em"}}
        >
            {opt.label}
        </Button>)
    }

    return (<>
        <h4>Features</h4>
        <div style={{ display: 'flex', flexDirection:'column', gap: '10px', padding: '10px', margin: '0 auto', maxWidth: '250px' }}>
            <h5>Governance</h5><br/>
           {options_governance.map(opt => (<>
                <OneButton opt={opt}/><br />
                </>))}
            <h5>Security</h5><br/>
            {options_security.map(opt => (<>
                <OneButton opt={opt}/><br />
                </>))}
                <br/>
        </div></>
    );
}

export default CreateContractOptions;